'use client'

import {
   Button,
   Card,
   Group,
   SimpleGrid,
   Stack,
   Text,
   ThemeIcon
} from '@blocks'
import {
   IconArrowRight,
   IconBrain,
   IconCheck,
   IconDeviceLaptop,
   IconPalette,
   IconRocket,
   IconShoppingCart
} from '@icons'

export const What = () => {
   return (
      <Stack
         id={'who'}
         my={100}
         gap={35}
      >
         <Stack
            align={'center'}
            justify={'center'}
            gap={10}
         >
            <Stack gap={5}>
               <Text
                  c={'#cb95ff'}
                  fw={500}
                  ta={'center'}
               >
                  SERVICES
               </Text>
               <Text
                  c={'white'}
                  fz={40}
                  fw={650}
                  ta={'center'}
               >
                  What We Do
               </Text>
            </Stack>
            <Text
               c={'white'}
               fz={22}
               ta={'center'}
               maw={'70%'}
            >
               We design and build digital products end to end. From
               concept to launch, we handle the complete delivery.
            </Text>
         </Stack>
         <SimpleGrid cols={{base: 1, md: 3}}>
            <Card
               p={40}
               radius={'lg'}
               style={{
                  background:
                     'linear-gradient(153deg, #6b3593d9, #390058d9)'
               }}
            >
               <Stack>
                  <ThemeIcon
                     p={10}
                     size={60}
                     color={'white'}
                     variant={'light'}
                     radius={'lg'}
                  >
                     <IconDeviceLaptop
                        stroke={2}
                        size={40}
                     />
                  </ThemeIcon>
                  <Text
                     c={'white'}
                     fz={20}
                     fw={650}
                  >
                     Custom Software & Websites
                  </Text>
                  <Text
                     c={'#dddddd'}
                     fz={18}
                     fw={500}
                  >
                     High-quality, bespoke digital solutions tailored
                     to your specific needs. From complex web
                     applications to elegant marketing sites.
                  </Text>
                  <Stack gap={10}>
                     <Group
                        align={'center'}
                        gap={10}
                        wrap={'nowrap'}
                     >
                        <IconCheck
                           size={20}
                           color={'#dddddd'}
                        />
                        <Text
                           c={'#dddddd'}
                           fz={18}
                           fw={500}
                        >
                           Full-stack web applications
                        </Text>
                     </Group>
                     <Group
                        align={'center'}
                        gap={10}
                        wrap={'nowrap'}
                     >
                        <IconCheck
                           size={20}
                           color={'#dddddd'}
                        />
                        <Text
                           c={'#dddddd'}
                           fz={18}
                           fw={500}
                        >
                           Responsive website design
                        </Text>
                     </Group>
                     <Group
                        align={'center'}
                        gap={10}
                        wrap={'nowrap'}
                     >
                        <IconCheck
                           size={20}
                           color={'#dddddd'}
                        />
                        <Text
                           c={'#dddddd'}
                           fz={18}
                           fw={500}
                        >
                           Progressive web apps (PWA)
                        </Text>
                     </Group>
                  </Stack>
               </Stack>
            </Card>
            <Card
               p={40}
               radius={'lg'}
               style={{
                  background:
                     'linear-gradient(153deg, #6b3593d9, #390058d9)'
               }}
            >
               <Stack>
                  <ThemeIcon
                     p={10}
                     size={60}
                     color={'white'}
                     variant={'light'}
                     radius={'lg'}
                  >
                     <IconBrain
                        stroke={2}
                        size={40}
                     />
                  </ThemeIcon>
                  <Text
                     c={'white'}
                     fz={20}
                     fw={650}
                  >
                     AI-Powered Experiences
                  </Text>
                  <Text
                     c={'#dddddd'}
                     fz={18}
                     fw={500}
                  >
                     Integrate cutting-edge AI capabilities into your
                     products. From intelligent automation to
                     predictive analytics.
                  </Text>
                  <Stack gap={10}>
                     <Group
                        align={'center'}
                        gap={10}
                        wrap={'nowrap'}
                     >
                        <IconCheck
                           size={20}
                           color={'#dddddd'}
                        />
                        <Text
                           c={'#dddddd'}
                           fz={18}
                           fw={500}
                        >
                           Machine learning integration
                        </Text>
                     </Group>
                     <Group
                        align={'center'}
                        gap={10}
                        wrap={'nowrap'}
                     >
                        <IconCheck
                           size={20}
                           color={'#dddddd'}
                        />
                        <Text
                           c={'#dddddd'}
                           fz={18}
                           fw={500}
                        >
                           Natural language processing
                        </Text>
                     </Group>
                     <Group
                        align={'center'}
                        gap={10}
                        wrap={'nowrap'}
                     >
                        <IconCheck
                           size={20}
                           color={'#dddddd'}
                        />
                        <Text
                           c={'#dddddd'}
                           fz={18}
                           fw={500}
                        >
                           Intelligent automation
                        </Text>
                     </Group>
                  </Stack>
               </Stack>
            </Card>
            <Card
               p={40}
               radius={'lg'}
               style={{
                  background:
                     'linear-gradient(153deg, #6b3593d9, #390058d9)'
               }}
            >
               <Stack>
                  <ThemeIcon
                     p={10}
                     size={60}
                     color={'white'}
                     variant={'light'}
                     radius={'lg'}
                  >
                     <IconPalette
                        stroke={2}
                        size={40}
                     />
                  </ThemeIcon>
                  <Text
                     c={'white'}
                     fz={20}
                     fw={650}
                  >
                     Brand-Aligned Development
                  </Text>
                  <Text
                     c={'#dddddd'}
                     fz={18}
                     fw={500}
                  >
                     Front-end and back-end development that perfectly
                     reflects your brand identity and business values.
                  </Text>
                  <Stack gap={10}>
                     <Group
                        align={'center'}
                        gap={10}
                        wrap={'nowrap'}
                     >
                        <IconCheck
                           size={20}
                           color={'#dddddd'}
                        />
                        <Text
                           c={'#dddddd'}
                           fz={18}
                           fw={500}
                        >
                           UI/UX design systems
                        </Text>
                     </Group>
                     <Group
                        align={'center'}
                        gap={10}
                        wrap={'nowrap'}
                     >
                        <IconCheck
                           size={20}
                           color={'#dddddd'}
                        />
                        <Text
                           c={'#dddddd'}
                           fz={18}
                           fw={500}
                        >
                           Brand consistency
                        </Text>
                     </Group>
                     <Group
                        align={'center'}
                        gap={10}
                        wrap={'nowrap'}
                     >
                        <IconCheck
                           size={20}
                           color={'#dddddd'}
                        />
                        <Text
                           c={'#dddddd'}
                           fz={18}
                           fw={500}
                        >
                           Scalable architecture
                        </Text>
                     </Group>
                  </Stack>
               </Stack>
            </Card>
            <Card
               p={40}
               radius={'lg'}
               style={{
                  background:
                     'linear-gradient(153deg, #6b3593d9, #390058d9)'
               }}
            >
               <Stack>
                  <ThemeIcon
                     p={10}
                     size={60}
                     color={'white'}
                     variant={'light'}
                     radius={'lg'}
                  >
                     <IconShoppingCart
                        stroke={2}
                        size={40}
                     />
                  </ThemeIcon>
                  <Text
                     c={'white'}
                     fz={20}
                     fw={650}
                  >
                     Ecommerce Solutions
                  </Text>
                  <Text
                     c={'#dddddd'}
                     fz={18}
                     fw={500}
                  >
                     Complete ecommerce platforms and Shopify
                     integrations that drive sales and enhance
                     customer experience.
                  </Text>
                  <Stack gap={10}>
                     <Group
                        align={'center'}
                        gap={10}
                        wrap={'nowrap'}
                     >
                        <IconCheck
                           size={20}
                           color={'#dddddd'}
                        />
                        <Text
                           c={'#dddddd'}
                           fz={18}
                           fw={500}
                        >
                           Custom Shopify themes
                        </Text>
                     </Group>
                     <Group
                        align={'center'}
                        gap={10}
                        wrap={'nowrap'}
                     >
                        <IconCheck
                           size={20}
                           color={'#dddddd'}
                        />
                        <Text
                           c={'#dddddd'}
                           fz={18}
                           fw={500}
                        >
                           Payment gateway integration
                        </Text>
                     </Group>
                     <Group
                        align={'center'}
                        gap={10}
                        wrap={'nowrap'}
                     >
                        <IconCheck
                           size={20}
                           color={'#dddddd'}
                        />
                        <Text
                           c={'#dddddd'}
                           fz={18}
                           fw={500}
                        >
                           Inventory management systems
                        </Text>
                     </Group>
                  </Stack>
               </Stack>
            </Card>
            <Card
               p={40}
               radius={'lg'}
               style={{
                  background:
                     'linear-gradient(153deg, #6b3593d9, #390058d9)'
               }}
            >
               <Stack>
                  <ThemeIcon
                     p={10}
                     size={60}
                     color={'white'}
                     variant={'light'}
                     radius={'lg'}
                  >
                     <IconRocket
                        stroke={2}
                        size={40}
                     />
                  </ThemeIcon>
                  <Text
                     c={'white'}
                     fz={20}
                     fw={650}
                  >
                     Startup & Enterprise Builds
                  </Text>
                  <Text
                     c={'#dddddd'}
                     fz={18}
                     fw={500}
                  >
                     Bespoke digital solutions for startups looking to
                     launch and established businesses ready to scale.
                  </Text>
                  <Stack gap={10}>
                     <Group
                        align={'center'}
                        gap={10}
                        wrap={'nowrap'}
                     >
                        <IconCheck
                           size={20}
                           color={'#dddddd'}
                        />
                        <Text
                           c={'#dddddd'}
                           fz={18}
                           fw={500}
                        >
                           MVP development
                        </Text>
                     </Group>
                     <Group
                        align={'center'}
                        gap={10}
                        wrap={'nowrap'}
                     >
                        <IconCheck
                           size={20}
                           color={'#dddddd'}
                        />
                        <Text
                           c={'#dddddd'}
                           fz={18}
                           fw={500}
                        >
                           Enterprise integrations
                        </Text>
                     </Group>
                     <Group
                        align={'center'}
                        gap={10}
                        wrap={'nowrap'}
                     >
                        <IconCheck
                           size={20}
                           color={'#dddddd'}
                        />
                        <Text
                           c={'#dddddd'}
                           fz={18}
                           fw={500}
                        >
                           Legacy system modernization
                        </Text>
                     </Group>
                  </Stack>
               </Stack>
            </Card>
         </SimpleGrid>
         <Stack
            align={'center'}
            justify={'center'}
            gap={'lg'}
         >
            <Text
               c={'white'}
               fz={22}
               ta={'center'}
               maw={'80%'}
            >
               Whether you have a fully formed brief or just the
               beginnings of an idea, we help shape, design, and
               deliver the right solution.
            </Text>
            <Group>
               <Button
                  c={'white'}
                  size={'lg'}
                  radius={'xl'}
                  variant={'gradient'}
                  gradient={{from: '#b98dd2', to: '#7c3aa0', deg: 90}}
                  rightSection={<IconArrowRight />}
               >
                  Discuss your project
               </Button>
            </Group>
         </Stack>
      </Stack>
   )
}
